<script setup lang="ts">
import {PolicyViewer} from '@teemill/modules/policy';
import {overlays} from '@teemill/modules/overlays';
import {ref} from 'vue';
import {TmlStorage} from '@teemill/common/classes';

const shouldShowManageCookiesButton = ref(false);

const onLoadPolicy = () => {
  setTimeout(() => {
    shouldShowManageCookiesButton.value = true;
  }, 500);
};

const openCookiePopup = () => {
  if (TmlStorage.local.get('cookies-accepted') === null) {
    snackbar('Please use the banner below to update your preferences');
    return;
  }

  window.gtag('consent', 'update', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
  });

  window.uetq.push('consent', 'update', {
    ad_storage: 'denied',
  });

  TmlStorage.local.remove('cookies-accepted');

  overlays.open('cookie-popup');
};
</script>

<template>
  <policy-viewer
    class="mt-8 mb-3"
    url-name="cookie-policy"
    :padding="false"
    @loaded="onLoadPolicy"
  />
  <tml-button
    v-if="shouldShowManageCookiesButton"
    class="mb-16"
    text="Manage cookies"
    @click="openCookiePopup"
  />
</template>
